<template>
  <div class="assessment-text-input">
    <label :for="inputId" class="assessment-text-input__label">{{ label }}</label>
    <input
      :id="inputId"
      :value="value"
      class="assessment-text-input__field"
      data-testid="assessment-text-input"
      type="text"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('entry-complete')"
      @keydown.enter="$emit('entry-complete')"
    >
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import './styles/TextInput.css'

export default defineComponent({
  name: 'AssessmentTextInput',
  props: {
    value: { type: [String, Number] as PropType<string | number | null>, default: null },
    inputId: { type: String, required: true },
    label: { type: String, required: true },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['input', 'entry-complete'],
})
</script>
